import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared top navigation for public (logged-out) pages: homepage, blog, etc.
 * Fixed to the top so the menu stays visible while reading. Section links
 * (Features / FAQ) point at the homepage anchors so they work from any page.
 */
const PublicNav: React.FC = () => {
  return (
    <nav className="fixed top-0 inset-x-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <div className="sf-nav flex items-center justify-between py-2.5 pl-4 pr-3">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="sf-logo-mark h-[34px] w-[34px] text-[19px]">S</span>
            <span className="text-xl font-extrabold tracking-tight text-fg-bright">SOLOFIX</span>
          </Link>
          <div className="hidden md:flex items-center gap-1.5">
            <a href="/#features" className="sf-nav-item">Features</a>
            <a href="/#faq" className="sf-nav-item">FAQ</a>
            <Link to="/blog" className="sf-nav-item">Blog</Link>
            <Link to="/login" className="sf-btn-secondary px-4 py-2 text-sm ml-1.5">Inloggen</Link>
            <Link to="/register" className="sf-btn-primary px-5 py-2 text-sm">
              Meld je aan
            </Link>
          </div>
          <div className="flex md:hidden items-center gap-1.5">
            <Link to="/login" className="sf-nav-item">Inloggen</Link>
            <Link to="/register" className="sf-btn-primary px-4 py-2 text-sm">Meld je aan</Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicNav;
